import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import SettingSideBar from './components/SettingSideBar';
import SettingAccountForm from './components/SettingAccountForm';

const EditAccount = ({ email }) => {
  const { t } = useTranslation();
  return ( 
    <div className="l-wrap-l">
      <h2 className="m-title-sub">{t('components.Navbar.Account_setting')}</h2>
      <div className="l-flex">
        <div className="l-flex3-sub">
          <SettingSideBar />
        </div>
        <div className="l-flex3-main">
          <SettingAccountForm email={email} />
        </div>
      </div>
    </div>
  );
};

export default connect()(EditAccount);
